// src/components/AddClienteRecepcion.jsx
import React from "react";
import AddClienteRecepcionForm from "./AddClienteRecepcionForm";

const AddClienteRecepcion = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nuevo Cliente Receptor"}
        </button>
      </div>

      {show && (
        <div className="mt-2">
          <AddClienteRecepcionForm setShow={setShow} />
        </div>
      )}
    </>
  );
};

export default AddClienteRecepcion;